import {User} from './user.model';
import {BankAccount} from './bank-account';
import {UserAddress} from './user-address.model';
import {LoanApplication} from './loan-application.model';
import {LivelihoodInformation} from './livelihood-information.model';
import {BorrowedInfo} from './borrowed-info.model';

export class Summary {
    private readonly name: string;
    private readonly amount: number;
    private readonly salary: number;
    private readonly tenure: number;
    private readonly address: string;
    private readonly bankName: string;
    private readonly bankIfsc: string;
    private readonly accountNo: string;
    private readonly income: number;
    private readonly employeeType: string;
    private readonly loanApplicationId: string;
    private readonly existingEmi: number | string;

    constructor(user: User, bankAccount: BankAccount, userAddress: UserAddress, loanApplication: LoanApplication,
                livelihoodInformation: LivelihoodInformation, borrowedInfo: BorrowedInfo) {
        this.name = user.name;
        this.bankIfsc = bankAccount.ifsc;
        this.address = userAddress.address;
        this.amount = loanApplication.amount;
        this.tenure = loanApplication.tenure;
        this.bankName = bankAccount.bank_name;
        this.accountNo = bankAccount.account_no;
        this.loanApplicationId = loanApplication.id;
        this.existingEmi = borrowedInfo ? borrowedInfo.sumOfEmis : 0;
        this.income = livelihoodInformation.income ? livelihoodInformation.income : 0;
        this.employeeType = livelihoodInformation.employeeType;
    }

    getUserName(): string {
        return this.name;
    }

    getLoanAmount(): number {
        return this.amount;
    }

    getTenure(): number {
        return this.tenure;
    }

    getAddress(): string {
        return this.address;
    }

    getBankName(): string {
        return this.bankName;
    }

    getBankIfsc(): string {
        return this.bankIfsc;
    }

    getLoanApplicationId(): string {
        return this.loanApplicationId;
    }

    getFormattedAccountNo(): string {
        return 'XXXXXXXXXX' + this.accountNo.substr(-4);
    }

    getExistingEmi(): number | string {
        return (this.existingEmi && this.existingEmi !== 0) ? this.existingEmi : 'None';
    }

    getIncome(): number {
        return this.income;
    }

    getSalariedType(): string {
        return this.employeeType.toUpperCase() === 'SALARIED' ? 'Net monthly salary' : 'Annual income';
    }
}
